import { NgModule } from '@angular/core';
import { LibSearchIconComponent } from './lib-search-icon.component';

@NgModule({
  declarations: [LibSearchIconComponent],
  imports: [],
  exports: [LibSearchIconComponent],
})
export class LibSearchIconModule {}
